

<template>

  <el-collapse-item name="图例" title="图例">

    <el-form-item label="显示">
      <el-switch v-model="ele.option.legend.show" active-color="#55aaff"
                 inactive-color="#ff557f">
      </el-switch>
    </el-form-item>

    <el-form-item label="文本颜色">
      <el-color-picker v-model="ele.option.legend.textStyle.color"
                       :predefine="['rgba(255, 255, 255, 1.0)','#ff4500',  '#ff8c00',  '#ffd700', '#90ee90',  '#00ced1', '#1e90ff',  '#c71585',  'rgba(255, 69, 0, 0.68)',  'rgb(255, 120, 0)',  'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)','#c7158577']"
                       show-alpha>
      </el-color-picker>
    </el-form-item>

    <el-form-item label="方向">
      <el-select v-model="ele.option.legend.orient">
        <el-option label="水平的" value="horizontal"></el-option>
        <el-option label="垂直的" value="vertical"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="类型">
      <template #label>
        类型
        <el-tooltip effect="dark" placement="bottom-start">
          <template #content>
            缺省就是普通图例。<br/> '滚动的'：可滚动翻页的图例。当图例数量较多时可以使用
          </template>
          <el-button icon="el-icon-s-help" text></el-button>
        </el-tooltip>
      </template>
      <el-select v-model="ele.option.legend.type">
        <el-option label="普通" value="plain"></el-option>
        <el-option label="滚动的" value="scroll"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="距离左侧距离">
      <template #label>
        距离左侧距离
        <el-tooltip effect="dark" placement="bottom-start">
          <template #content>
            图例组件离容器左侧的距离 <br/>可以是像 20 这样的具体像素值<br/>
            可以是像 '20%' 这样相对于容器高宽的百分比<br/>
            也可以是 'left', 'center', 'right'
          </template>
          <el-button icon="el-icon-s-help" text></el-button>
        </el-tooltip>
      </template>
      <el-input v-model="ele.option.legend.left"></el-input>
    </el-form-item>

    <el-form-item label="宽度">
      <template #label>
        宽度
        <el-tooltip effect="dark" placement="bottom-start">
          <template #content>
            图例组件的宽度。默认自适应 auto
          </template>
          <el-button icon="el-icon-s-help" text></el-button>
        </el-tooltip>
      </template>
      <el-input v-model="ele.option.legend.width"></el-input>
    </el-form-item>

    <el-form-item label="高度">
      <template #label>
        高度
        <el-tooltip effect="dark" placement="bottom-start">
          <template #content>
            图例组件的高度。默认自适应 auto
          </template>
          <el-button icon="el-icon-s-help" text></el-button>
        </el-tooltip>
      </template>
      <el-input v-model="ele.option.legend.height"></el-input>
    </el-form-item>

    <el-form-item label="间距">
      <template #label>
        间距
        <el-tooltip effect="dark" placement="bottom-start">
          <template #content>
            图例每项之间的间隔。横向布局时为水平间隔，纵向布局时为纵向间隔
          </template>
          <el-button icon="el-icon-s-help" text></el-button>
        </el-tooltip>
      </template>
      <el-input-number v-model="ele.option.legend.itemGap"></el-input-number>
    </el-form-item>

    <el-form-item label="top">
      <el-input v-model="ele.option.legend.top"></el-input>
    </el-form-item>

    <el-form-item label="bottom">
      <el-input v-model="ele.option.legend.bottom"></el-input>
    </el-form-item>

  </el-collapse-item>

</template>

<script>
export default {

  props: {
    element: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      ele: null
    }
  },
  created() {
    this.ele = this.element;
  },

}

</script>

<style scoped lang="scss">

</style>